import { getReferralByTackleId } from 'packages/tackle-api/src/co-sell-msft';
import { useQuery } from '@tanstack/react-query';

const useMsftReferral = ({ tackleId }: { tackleId: string }) => {
  return useQuery({
    queryKey: ['getMsftReferral', tackleId],
    queryFn: () => getReferralByTackleId({ tackleId }),
    enabled: !!tackleId,
  });
};

export default useMsftReferral;
